import React, { useState } from "react";
import { Button, Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";

import { editField } from "../../../redux";
import CustomList from "./CustomList";

const TransferTree = ({ featureNumber = 0, data = [] }) => {
  const dispatch = useDispatch();
  const [searchValRight, setSearchValRight] = useState("");
  const [searchValLeft, setSearchValLeft] = useState("");
  const [selected, setSelected] = useState([]);
  const [left, setLeft] = useState(data);
  const [right, setRight] = useState([]);

  const extendSelectedList = () =>
    data.filter((item) => selected.includes(`${item.valueDMA}`));

  const not = (a = [], b = []) => a.filter((value) => b.indexOf(value) === -1);

  const intersection = (targetList = []) => {
    return extendSelectedList().filter(
      (item) => targetList.indexOf(item) !== -1
    );
  };

  const leftChecked = intersection(left);
  const rightChecked = intersection(right);

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setSelected([]);
    setSearchValLeft("");
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setSelected([]);
    setSearchValRight("");
  };

  return (
    <div>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item>
          <CustomList
            searchVal={searchValLeft}
            setSearchVal={setSearchValLeft}
            items={left}
            listHeader={"Available DMA"}
            selected={selected}
            setSelected={setSelected}
          />
        </Grid>
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt;
            </Button>
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt;
            </Button>
          </Grid>
        </Grid>
        <Grid item>
          <CustomList
            searchVal={searchValRight}
            setSearchVal={setSearchValRight}
            items={right}
            listHeader={"Target/Existing DMA"}
            selected={selected}
            setSelected={setSelected}
          />
        </Grid>
      </Grid>
      <div
        style={{
          marginTop: 20,
          paddingRight: 88,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-end",
        }}
      >
        <Button
          style={{
            marginRight: 20,
          }}
          sx={{ my: 0.5 }}
          variant="outlined"
          size="small"
          onClick={() => {
            setLeft(data);
            setRight([]);
            return dispatch(
              editField(`root[${featureNumber}].targeting.dma`, [])
            );
          }}
          disabled={right.length === 0}
          aria-label="Clear All"
        >
          Clear All
        </Button>
        <Button
          sx={{ my: 0.5 }}
          variant="outlined"
          size="small"
          onClick={() => {
            const appliedItem = right.map((item) => item.valueDMA);
            return dispatch(
              editField(
                `root[${featureNumber}].targeting.dma`,
                Array.from(
                  new Set([...appliedItem].filter((item) => item !== undefined))
                )
              )
            );
          }}
          disabled={right.length === 0}
          aria-label="Apply"
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default TransferTree;
